import { render, staticRenderFns } from "./ChangePin.vue?vue&type=template&id=be688408&scoped=true&"
import script from "./ChangePin.vue?vue&type=script&lang=js&"
export * from "./ChangePin.vue?vue&type=script&lang=js&"
import style0 from "./ChangePin.vue?vue&type=style&index=0&id=be688408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be688408",
  null
  
)

export default component.exports